import React, { useState, useEffect } from 'react';
import axios from 'axios';

export const buildImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:image")) {
    return url;
  }
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (url.startsWith("/api")) {
    return `${backendUrl}${url}`;
  }
  if (url.startsWith("/")) {
    return `${backendUrl}/api${url}`;
  }
  return `${backendUrl}/api/${url}`;
};

export function AuthenticatedImage({ src, alt, className, fallbackText = "No Photo Uploaded" }) {
  const [imgSrc, setImgSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!src) {
      setImgSrc(null);
      setLoading(false);
      setError(true);
      return;
    }

    let active = true;
    const fetchImage = async () => {
      setLoading(true);
      setError(false);
      try {
        const fullUrl = buildImageUrl(src);
        const response = await axios.get(fullUrl, {
          responseType: 'blob',
          withCredentials: true
        });
        if (active) {
          const url = URL.createObjectURL(response.data);
          setImgSrc(url);
        }
      } catch (err) {
        if (active) {
          setError(true);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchImage();

    return () => {
      active = false;
      if (imgSrc) {
        URL.revokeObjectURL(imgSrc);
      }
    };
  }, [src]);

  if (loading) {
    return (
      <div className={`${className} flex items-center justify-center bg-slate-50 text-slate-400 text-xs`}>
        <span className="animate-pulse">Loading…</span>
      </div>
    );
  }

  if (error || !imgSrc) {
    return (
      <div className={`${className} flex items-center justify-center bg-slate-100 text-slate-400 text-[10px] font-medium text-center p-2 border border-slate-200 border-dashed rounded-lg`}>
        {fallbackText}
      </div>
    );
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
    />
  );
}
